import CustomFilterSelect from '../../../shared/customFilterSelect';
import './style.scss';
import {getNeighborhoods, getUsers} from "../../../API/apiService";
import {useEffect, useState} from "react";

function EditGroup({
                       setEditModal,
                       motherOrganization,
                       year,
                       sourceType,
                       school,
                       municipalities,
                       editGroup
                   }) {
    // STATES //
    const [neighborhoods, setNeighborhoods] = useState([]);
    const [selectedMunicipality, setSelectedMunicipality] = useState(null);
    const [facilitators, setFacilitators] = useState([]);
    const [formData, setFormData] = useState({
        schoolId: '',
        groupId: '',
        schoolCode: '',
        groupRange: '',
        municipalityId: '',
        neighborhoodId: '',
        year: '',
        resourceId: '',
        organization: '',
        facilitatorId: '',
        groupCode: '',
    });

    const ages = [
        {
            name: 'N1',
            id: 'N1'
        },
        {
            name: 'N2',
            id: 'N2'
        },
        {
            name: 'N3',
            id: 'N3'
        }
    ];

    async function getNeighborhoodsInfo() {
        if (selectedMunicipality) {
            const data = await getNeighborhoods(selectedMunicipality)
            if (data) {
                setNeighborhoods(data)
            }
        }
    }

    async function getFacilitators() {
        const data = await getUsers()
        if (data) {
            setFacilitators(data.map(u => {
                return {id: u.id, name: u.full_name}
            }))
        }
    }

    function addInfo(selectName, id, value) {
        switch (selectName) {
            case 'municipalityId':
                setSelectedMunicipality(id);
                break;
        }
        setFormData({...formData, [selectName]: id});
    }

    useEffect(() => {
        getNeighborhoodsInfo();
    }, selectedMunicipality);

    useEffect(() => {
        getFacilitators();
    }, []);

    useEffect(() => {
        formData.schoolCode = school.code;
        formData.schoolId = school.id;
        formData.year = school.year;
        formData.organization = school.groupInfo.organization ?? school.organization;
        formData.resourceId = school.resource.id;
        formData.facilitatorId = school.groupInfo.user_id ?? school.user_id;
        formData.groupId = school.groupInfo.id;
        formData.groupCode = school.groupInfo.code;
        formData.groupRange = school.groupInfo.age_range;
        formData.municipalityId = school.groupInfo.municipality_id ?? school.municipality_id;
        formData.neighborhoodId = school.groupInfo.neighborhood_id ?? school.neighborhood_id;
    }, school);

    return (
        <section className='main-editGroup-container'>
            <p className='title'>EDITAR GRUPO ESCUELA</p>
            <section className='create-container'>

                <div>
                    <label className='label' htmlFor=''>
                        <input
                            placeholder='Nombre Grupo'
                            type='text'
                            name='groupCode'
                            className='input-form'
                            value={formData.groupCode}
                            onChange={e => addInfo('groupCode', e.target.value)}

                        />
                    </label>
                </div>

                <CustomFilterSelect
                    optionsList={ages}
                    valueEdit={school.groupInfo.age_range}
                    placeholder={'Seleccione el Rango'}
                    addInfo={addInfo}
                    keyName={'groupRange'}
                />
                <div className='dinamizador-container'>
                    <CustomFilterSelect
                        optionsList={facilitators}
                        valueEdit={school?.groupInfo?.user?.full_name??school?.user?.full_name}
                        placeholder={'Nombre del dinamizador'}
                        addInfo={addInfo}
                        keyName={'facilitatorId'}
                    />
                </div>
                <div className='place-info-container'>
                    <CustomFilterSelect
                        placeholder={'Comuna'}
                        valueEdit={school?.groupInfo?.municipality?.name??school?.municipality?.name}
                        optionsList={municipalities}
                        addInfo={addInfo}
                        keyName={'municipalityId'}
                    />
                    <CustomFilterSelect
                        valueEdit={school?.groupInfo?.neighborhood?.name??school?.neighborhood?.name}
                        placeholder={'Barrios'}
                        optionsList={neighborhoods}
                        addInfo={addInfo}
                        keyName={'neighborhoodId'}
                    />
                    <CustomFilterSelect
                        valueEdit={school.resource?.name}
                        placeholder={'Tipo de recurso'}
                        optionsList={sourceType}
                        addInfo={addInfo}
                        keyName={'resourceId'}
                    />
                    <label className='label' htmlFor=''>
                        <input
                            placeholder='Año'
                            type='text'
                            name='year'
                            className='input-form'
                            readOnly={true}
                            value={formData.year}
                        />
                    </label>
                </div>
                <div className='motherOrg-container'>
                    <label className='label' htmlFor=''>
                        <input
                            placeholder='Organizacion Madrina'
                            type='text'
                            name='organization'
                            className='input-form'
                            value={formData.organization}
                            onChange={e => addInfo('organization', e.target.value)}

                        />
                    </label>
                </div>
                <div className='buttons-container'>
                    <button className='blue-site-button create'
                            onClick={()=> editGroup(formData)}>
                        GUARDAR
                    </button>
                    <button
                        className='button-white-border-blue'
                        onClick={() => setEditModal(false)}>
                        CANCELAR
                    </button>
                </div>
            </section>
        </section>
    );
}

export default EditGroup;